import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

export default {
  install(Vue, { culture }) {
    dayjs.extend(customParseFormat);

    Vue.prototype.$filters = {
      async getFormats() {
        const config = {
          params: {
            action: 'get_format',
            culture
          }
        };
        const { data } = await Vue.prototype.$wiswiseproxyclient.post(
          {},
          config
        );

        window.formats = data;
      },
      getCurrencyCode() {
        if (window.formats) {
          return window.formats.currency_format.symbol.trim() === '€'
            ? 'EUR'
            : 'USD';
        }
      },
      getCurrencySymbol() {
        if (window.formats) {
          return window.formats.currency_format.symbol;
        }
      }
    };

    Vue.filter('currency', input => {
      if (isNaN(input)) return '-';

      if (window.formats && window.formats.currency_format) {
        const ds = window.formats.currency_format.decimal_separator;
        const ts = window.formats.currency_format.thousand_separator;
        return `${window.formats.currency_format.symbol}${Number(input).toFixed(
          2
        )}`
          .replace('.', ds)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      }

      let currency = 'EUR';
      if (['en-US', 'es-US'].includes(culture)) {
        currency = 'USD';
      }

      const formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return formatter.format(input);
    });

    Vue.filter('date', input => {
      const timezoneOffset = 'T00:00:00';
      const date = new Date(input + timezoneOffset);
      if (!(date instanceof Date && !isNaN(date))) return ''; // invalid date
      if (window.formats && window.formats.date_format) {
        return dayjs(date).format(window.formats.date_format);
      }
      return date.toLocaleDateString(culture);
    });

    Vue.filter('monthLabel', input => {
      const timezoneOffset = 'T00:00:00';
      const date = new Date(input + timezoneOffset);
      if (!(date instanceof Date && !isNaN(date))) return '-'; // invalid date
      return date.toLocaleDateString(culture, { month: 'long' });
    });

    Vue.filter('percentage', input => {
      if (isNaN(input)) return '-';

      if (window.formats && window.formats.currency_format) {
        const ds = window.formats.currency_format.decimal_separator;
        const ts = window.formats.currency_format.thousand_separator;
        return `${Number(input).toFixed(2)}%`
          .replace('.', ds)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ts)
          .replace('0%', '%')
          .replace(`${ds}0%`, '%');
      }

      const formatter = new Intl.NumberFormat(culture, {
        style: 'percent',
        maximumFractionDigits: 2
      });
      return formatter.format(input / 100);
    });
  }
};
